import { AppointmentPaymentErrorCard } from "../components/payment-card";

export function AppointmentBookingError() {
    return (
        <AppointmentPaymentErrorCard />
    );
}
